var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { sportsDict, datesDict, marketGroupsDict } from "./dict";
import { config, marketGroupsDefaultConfig } from "./config";
import { FilterBlock } from "./FilterBlock";
import { sportsRetrieversFactory, sportsParserFactory, datesRetrieverFactory, datesParserFactory, sportsStateFactory, datesStateFactory, getTimeZoneObservable, getUserInfoObservable, marketGroupsRetrieverFactory, marketGroupsStateFactory, marketGroupsParserFactory } from "../../modes";
import { BFFGateway } from "sb-bff-integration";
let _localMocks;
let BFFGatewayMock;
if (process.env.NODE_ENV === "development") {
    _localMocks = require("../../mocks");
    BFFGatewayMock = _localMocks.BFFGatewayMock;
}
export class FilterBlockRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: sportsDict,
        cms: config,
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {},
        gameStatus: {},
        timeControl: {},
        panelId: "",
        storageUtils: {},
        userInfo: {}
    }) {
        super(domId, options);
        this.retrievers = [];
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, this.getDictionary(options.cms.mode)), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, this.getConfig(options.cms.mode)), (options.cms || {}));
        this.timeZoneObservable = getTimeZoneObservable();
        this.userInfoObservable = getUserInfoObservable();
        this.timeZoneObservable.activate();
        this.userInfoObservable.activate();
        this.initState();
        if (process.env.NODE_ENV === "development") {
            //export data store to window for debug purposes
            window["FilterBlockDATA"] = this.state;
        }
    }
    getDictionary(mode) {
        switch (mode) {
            case "Dates":
                return datesDict;
            case "Markets":
                return marketGroupsDict;
        }
        return sportsDict;
    }
    getConfig(mode) {
        switch (mode) {
            case "Markets":
                return marketGroupsDefaultConfig;
        }
        return config;
    }
    initState() {
        switch (this.options.cms.mode) {
            case "Sport":
                this.initSports(this.options.cms);
                break;
            case "Dates":
                this.initDates(this.options.cms);
                break;
            case "Markets":
                this.initMarkets(this.options.cms);
                break;
        }
    }
    initSports(cms) {
        const bffGateway = this.initBFFGateway();
        this.retrievers = sportsRetrieversFactory(cms, this.options.dict, this.timeZoneObservable, this.userInfoObservable, bffGateway);
        this.state = sportsStateFactory(cms, this.domId);
        this.parser = sportsParserFactory(cms, this.retrievers);
    }
    initDates(cms) {
        const bffGateway = this.initBFFGateway();
        const retriever = datesRetrieverFactory(cms, this.options.dict, this.timeZoneObservable, bffGateway);
        this.retrievers.push(retriever);
        this.state = datesStateFactory(cms, this.domId);
        this.parser = datesParserFactory(cms, retriever);
    }
    initMarkets(cms) {
        const bffGateway = this.initBFFGateway();
        const retriever = marketGroupsRetrieverFactory(cms, this.options.dict, bffGateway);
        this.retrievers.push(retriever);
        this.state = marketGroupsStateFactory(cms, this.domId);
        this.parser = marketGroupsParserFactory(cms, retriever);
    }
    activate() {
        this.activateAsync().then(() => !this.isActive && this.cleanup()).catch((reason) => this.cleanup());
        return super.activate(React.createElement(FilterBlock, { state: this.state, config: this.options.cms }));
    }
    activateAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.parser.activate(this.state);
            this.state.activate();
        });
    }
    deactivate() {
        this.cleanup();
        return super.deactivate();
    }
    cleanup() {
        this.retrievers.forEach(r => r.deactivate());
        this.state.deactivate();
        this.parser.deactivate();
        this.state.clear();
    }
    setParams(...params) {
        this.retrievers.forEach(r => r.setParams(...params));
    }
    setBranch(itemId) {
        this.state.selectItemById("" + itemId);
    }
    destroy() {
        this.timeZoneObservable.deactivate();
        this.userInfoObservable.deactivate();
        return this;
    }
    onPanelEnter() {
        this.retrievers.forEach(r => r.onPanelEnter());
        return this;
    }
    onPanelLeave() {
        this.retrievers.forEach(r => r.onPanelLeave());
        return this;
    }
    initBFFGateway() {
        return process.env.NODE_ENV === "development" ? new BFFGatewayMock() : new BFFGateway().withBlockId(this.options.cms.blockId);
    }
}
window["FilterBlock"] = FilterBlockRoot;
broadcastBlockLoad("FilterBlock");
//# sourceMappingURL=index.js.map